import React, { createContext, useState, useEffect } from 'react';

import { ContactStateType, ContactModalStateType } from '../types';
import { ContactModalMode } from '../enums';

type ContactModalStateContextProviderProps = {
  contactForEdit?: Partial<ContactStateType>;
  isProfile: boolean;
  userId?: string;
  listingId: string;
  listing: any;
  isMustCallDisabled: boolean;
  onContactModalStateChange: (state: ContactModalStateType) => void;
};

const ContactModalStateContext = createContext<
  [
    Omit<ContactModalStateContextProviderProps, 'onContactModalStateChange'> &
      ContactModalStateType,
    (update: Partial<ContactModalStateType>) => void,
  ]
>(null!);

export default ContactModalStateContext;

export const ContactModalStateContextProvider: React.FC<
  ContactModalStateContextProviderProps
> = ({
  contactForEdit,
  isProfile,
  userId,
  listingId,
  listing,
  isMustCallDisabled,
  onContactModalStateChange,
  children,
}) => {
  const [contactModalState, setContactModalState] =
    useState<ContactModalStateType>({
      contactInputsDisabled: !!contactForEdit,
      mode: contactForEdit
        ? ContactModalMode.EditConfig
        : ContactModalMode.AddNew,
      listingId,
      isEditMode: !!contactForEdit,
    });

  useEffect(() => {
    onContactModalStateChange(contactModalState);
  }, [contactModalState, onContactModalStateChange]);

  const updateContactModalState = (update: Partial<ContactModalStateType>) => {
    setContactModalState(prevState => ({
      ...prevState,
      ...update,
    }));
  };

  return (
    <ContactModalStateContext.Provider
      value={[
        {
          contactForEdit,
          isProfile,
          userId,
          ...contactModalState,
          listing,
          isMustCallDisabled,
        },
        updateContactModalState,
      ]}
    >
      {children}
    </ContactModalStateContext.Provider>
  );
};
